<template>
  <div>
    <div class="p-4" style="background-color: white;">
      <div class="d-flex align-items-center justify-content-between">
        <h2>
          {{ mode === 'create' ? 'Create New Audience' : 'Edit Audience' }}
        </h2>
        <a href="#" v-on:click="handleViewInstructions">View Instructions</a>
      </div>
      <form action="" v-on:submit.prevent="handleSubmit">
        <div class="mb-3">
          <label for="name" class="form-label"
            ><span style="color: red" v-if="mode === 'create'">*&nbsp;</span
            >Name:
          </label>
          <input
            type="text"
            name="name"
            id="name"
            placeholder="Audience Name - Max 30 characters"
            class="form-control"
            v-model="name"
            :disabled="
              api['CREATE-AUDIENCE'].loading ||
                api['EDIT-AUDIENCE'].loading ||
                api['VALIDATE-CSV'].loading ||
                mode !== 'create'
            "
          />
          <form-field-error-label
            v-for="error in validationErrors.name"
            :key="error"
            :error="error"
          ></form-field-error-label>
        </div>
        <div class="mb-3">
          <label class="form-label">
            <span style="color: red" v-if="mode === 'create'">*&nbsp;</span
            >CSV<span v-if="mode === 'edit'"
              ><em>(new CSV will replace existing data)</em></span
            ></label
          >:
          <div>
            <label
              for="csv"
              style="
              display: flex;
              width: 100%;
              height: 35px;
              font-size: 0.95rem;
              font-weight: 400;
              line-height: 1.2;
              color: #3b4054;    background-clip: padding-box;
              border: 1px solid #ced4da;
              border-radius: 0.125rem;
              align-items: center;
              flex-direction: row;
              "
            >
              <div
                style="height: 35px; width: 35px;display: flex; align-items: center; justify-content: center; background-color: #13a3eb;"
              >
                <div style="height: 20px; height: 20px;">
                  <icon-plus-thick color="#ffffff"></icon-plus-thick>
                </div>
              </div>
              <p
                :style="
                  `margin-bottom: 0px; margin-left: 8px; color: ${
                    csv ? 'black' : '#898c98'
                  } `
                "
              >
                {{ !csv ? 'Attach CSV file' : csv.name }}
              </p>
            </label>
            <input
              type="file"
              name="csv"
              id="csv"
              style="display: none;"
              v-on:change="handleFileChanged"
              ref="csv"
              accept=".csv"
              :disabled="
                api['CREATE-AUDIENCE'].loading ||
                  api['EDIT-AUDIENCE'].loading ||
                  api['VALIDATE-CSV'].loading
              "
            />
          </div>
          <form-field-error-label
            v-for="error in validationErrors.csv"
            :key="error"
            :error="error"
          ></form-field-error-label>
          <div>
            <p class="text-right mt-1">
              <a href="#" @click.prevent="handleDownloadCsvTemplateClicked"
                >Download CSV Template</a
              >
            </p>
          </div>
        </div>
        <div class="mb-3">
          <p class="mb-0">
            <span style="color: red" v-if="mode === 'create'">*&nbsp;</span
            >Select Audience Type:
          </p>
          <form-field-error-label
            v-for="error in validationErrors.scope"
            :key="error"
            :error="error"
          ></form-field-error-label>
          <div class="form-check">
            <input
              type="radio"
              name="availability"
              id="availability-global"
              value="client"
              v-model="scope"
              :disabled="
                api['CREATE-AUDIENCE'].loading ||
                  api['EDIT-AUDIENCE'].loading ||
                  api['VALIDATE-CSV'].loading
              "
            />
            <label for="availability-global" class="mb-0 ml-1">Global</label>
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="availability"
              id="availability-office"
              value="agency"
              v-model="scope"
              :disabled="
                api['CREATE-AUDIENCE'].loading ||
                  api['EDIT-AUDIENCE'].loading ||
                  api['VALIDATE-CSV'].loading
              "
            />
            <label for="availability-office" class="mb-0 ml-1"
              >Office
              <a
                href="#"
                @click.prevent="openModal"
                style="font-size: 14px;"
                v-if="scope === 'agency' && scopeIds"
                >Select Office/s Access</a
              ></label
            >
          </div>
          <div class="form-check">
            <input
              type="radio"
              name="availability"
              id="availability-agent"
              value="agent"
              v-model="scope"
              style="margin-bottom: -2px;"
              :disabled="
                api['CREATE-AUDIENCE'].loading ||
                  api['EDIT-AUDIENCE'].loading ||
                  api['VALIDATE-CSV'].loading
              "
            />
            <label for="availability-agent" class="mb-0 ml-1"
              >Agent
              <a
                href="#"
                @click.prevent="openModal"
                style="font-size: 14px;"
                v-if="scope === 'agent' && scopeIds"
                >Select Agent/s Access</a
              >
            </label>
          </div>
          <div>
            <p>
              <strong>
                {{
                  scope === 'client'
                    ? 'Global access selected: All users'
                    : null
                }}
                {{
                  scopeIds.length && scope !== 'client' > 0
                    ? scopeIds.length
                    : null
                }}
                {{
                  scope === 'agency' && scopeIds.length > 0
                    ? 'Office(s) access selected:'
                    : null
                }}
                {{
                  scope === 'agent' && scopeIds.length > 0
                    ? 'Agent(s) access selected:'
                    : null
                }}
              </strong>
              <em v-if="scopeIds.length > 0">{{ selectList }}</em>
            </p>
          </div>
        </div>
        <div style="display: flex; justify-content: space-between;">
          <app-primary-button
            type="submit"
            :disabled="
              disabledSubmit ||
                api['CREATE-AUDIENCE'].loading ||
                api['EDIT-AUDIENCE'].loading ||
                api['VALIDATE-CSV'].loading
            "
            :loading="
              api['CREATE-AUDIENCE'].loading ||
                api['EDIT-AUDIENCE'].loading ||
                api['VALIDATE-CSV'].loading
            "
            :label="mode === 'create' ? 'Create' : 'Update'"
          ></app-primary-button>
          <button
            type="button"
            class="btn btn-quaternary"
            style="align-self: flex-end;"
            @click="handleCancelEdit"
            v-if="mode === 'edit'"
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
    <audience-availability-list-modal
      v-if="showModal"
      :data="columnData"
      :onClose="handleModalClose"
      @items-selected="handleItemsSelected"
      :scope="scope"
    ></audience-availability-list-modal>
    <audience-instruction-modal
      :visible="showInstructionsModal"
      @close-modal="closeInstructionsModal"
    ></audience-instruction-modal>
    <app-modal-progress-bar
      v-if="showLoadingModal"
      :progress="loadingModalProgress"
      :label="loadingModalLabel"
      :state="loadingModalState"
    ></app-modal-progress-bar>
  </div>
</template>

<script>
import AudienceAvailabilityListModal from './AudienceAvailabilityListModal.vue';
import {
  AGENCY_COLUMNS,
  AudienceAvailabilityListModalData,
  AGENT_COLUMNS,
} from './AudienceAvailabilityListModalData';
import ApiCallMixin from '../../../mixins/ApiCallMixin';
import LookupServices from '../../../services/lookups';
import store from '../../../store';
import AudienceServiceV2 from '../../../services/V2/AudienceServiceV2';
import FormFieldErrorLabel from '../../AppComponents/Forms/FormFieldErrorLabel.vue';
import AppPrimaryButton from '../../AppComponents/Forms/AppPrimaryButton.vue';
import AudienceInstructionModal from './AudienceInstructionModal.vue';
import iconPlusThick from '../../../assets/icons/icon-plus-thick.vue';
import AppModalProgressBar from '../../AppComponents/Loaders/AppModalProgressBar.vue';

export default {
  mixins: [ApiCallMixin],
  props: ['data', 'mode'],
  data() {
    return {
      name: null,
      csv: null,
      scope: null,
      scopeIds: [],
      assignments: [],
      showModal: false,
      showInstructionsModal: false,
      showLoadingModal: false,
      loadingModalProgress: 0,
      loadingModalState: 'loading',
      loadingModalLabel: '',
    };
  },
  components: {
    AudienceAvailabilityListModal,
    FormFieldErrorLabel,
    AppPrimaryButton,
    AudienceInstructionModal,
    iconPlusThick,
    AppModalProgressBar,
  },
  methods: {
    handleFileChanged(e) {
      this.csv = e.target.files[0];
    },
    handleModalClose() {
      this.showModal = false;
    },
    handleItemsSelected(items) {
      if (this.scope === 'agency') {
        this.assignments = items.map((agency) => ({
          id: agency.id,
          name: agency.displayName || agency.title,
        }));
      } else if (this.scope === 'agent') {
        this.assignments = items.map((agent) => ({
          id: agent.id,
          name: `${agent.firstName || ''} ${agent.lastName || ''}`,
        }));
      }
      this.scopeIds = items.map((item) => item.id);
    },
    handleCancelEdit() {
      this.$emit('on-edit-cancelled');
      this.resetFormState();
    },
    resetFormState() {
      this.name = null;
      this.csv = null;
      this.$refs.csv.value = null;
      this.scope = null;
      this.scopeIds = [];
      this.assignments = [];
    },
    async handleDownloadCsvTemplateClicked() {
      try {
        const response = await AudienceServiceV2.downloadCsvTemplate();

        const filename = response.headers['acquire-filename'];

        const pdfBlob = new Blob([response.data], {type: 'text/csv'});

        const downloadUrl = window.URL.createObjectURL(pdfBlob);
        const link = document.createElement('a');
        link.href = downloadUrl;
        link.download = filename; // Set the file name
        document.body.appendChild(link);
        link.click();

        window.URL.revokeObjectURL(downloadUrl);
        document.body.removeChild(link);
      } catch (error) {
        this.$swal({
          type: 'error',
          title: 'Download failed',
          text: 'The CSV template could not be downloaded at this time.',
        });
      }
    },
    async handleSubmit() {
      if (this.csv) {
        if ((await this.validateAudienceCsv(this.csv)) === false) return;
        if ((await this.confirmatDataPrivacy()) === false) return;
      }

      const formData = this.assemblePayload(new FormData());

      const interval = this.startLoadingModal(
        this.mode === 'create' ? 'Creating Audience' : 'Updating Audience'
      );
      if (this.mode === 'create') {
        await this.handleCreateAudience(formData);
      } else {
        await this.handleEditAudience(formData);
      }
      this.endLoadingModal(interval,
        this.api[ this.mode === 'create' ? 'CREATE-AUDIENCE' : 'EDIT-AUDIENCE' ]
          .hasError === false
      )
    },
    async handleCreateAudience(formData) {
      const response = await this.request(
        'CREATE-AUDIENCE',
        AudienceServiceV2.createAudience,
        formData
      );

      if (this.api['CREATE-AUDIENCE'].hasError === false) {
        this.$swal({
          type: 'success',
          title: 'Audience created!',
          text: `Audience ${this.name} has been created successfully.`,
        });

        this.resetFormState();
        this.$emit('on-audience-created', response.data);
      }
    },
    async handleEditAudience(formData) {
      const response = await this.request(
        'EDIT-AUDIENCE',
        AudienceServiceV2.updateAudience,
        this.data.id,
        formData
      );

      if (this.api['EDIT-AUDIENCE'].hasError === false) {
        this.$swal({
          type: 'success',
          title: 'Audience updated!',
          text: `Audience ${this.name} has been updated successfully.`,
        });

        this.$emit('on-audience-edited', response.data);
      }
    },
    async validateAudienceCsv(csv) {
      try {
        const form = new FormData();
        form.append('csv', csv);
        await this.request(
          'VALIDATE-CSV',
          AudienceServiceV2.validateAudienceCsv,
          form
        );

        const error = this.api['VALIDATE-CSV'].error;

        if (error && error.response && error.response.status === 422) {
          if (error.response.data.message.startsWith('Row ')) {
            const validationConfirmation = await this.$swal({
              type: 'error',
              title: 'Review required for your audience CSV',
              text:
                'The CSV contains items that require your attention. Would you like to proceed with uploading this file?',
              showCancelButton: true,
              cancelButtonText: 'Download report and review ',
              confirmButtonText: 'Proceed with upload',
            });

            if (validationConfirmation.dismiss) {
              this.downloadCsvErrors(error.response.data.errors.csv.join('\n'));
              return false;
            }
          }
        }
      } catch (error) {}

      return true;
    },
    async confirmatDataPrivacy() {
      const confirmed = await this.$swal({
        html:
          '<p>You agree to provide View Media Group Pty Ltd (<strong>View</strong>) a hashed, unidentifiable customer list (<strong>Customer List</strong>) to be transferred to Meta via API to data match and create a targeted audience.<br><br>You warrant all personal information within the Customer List was collected in accordance with the Privacy Act 1988 and consent was obtained to transfer personal information in the Customer List to View and Meta.<br><br>You are bound by the <a target="_blank" href="https://www.facebook.com/legal/terms/customaudience">Meta Customer List Custom Audiences Terms</a>.<br><br>View disclaims all liability for your and Meta’s collection and use of the Customer List. You indemnify and hold View harmless for any loss or liability it incurs related to providing the Customer List to Meta, and your and Metas actions, including misuse, unauthorised use, data breach or non-compliance with law.</p>',
        type: 'success',
        title: '',
        showCancelButton: true,
      });

      return confirmed.value === true;
    },
    assemblePayload(formData) {
      if (this.mode === 'create') {
        formData.append('name', this.name);
      }

      if (this.csv) {
        formData.append('csv', this.csv);
      }
      formData.append('scope', this.scope);

      if (this.scope === 'client') {
        formData.append('uuids[]', store.getters.getUser.clientId);
      } else {
        this.scopeIds.forEach((id) => formData.append('uuids[]', id));
      }

      return formData;
    },
    async startLoadingModal(label) {
      this.loadingModalLabel = label;
      this.loadingModalProgress = 0;
      this.loadingModalState = 'loading';
      this.showLoadingModal = true;

      setTimeout(() => {
        this.loadingModalProgress = 20;
      }, 250);

      setTimeout(() => {
        this.loadingModalProgress = 70;
      }, 2000);

      let interval = setInterval(() => {
        if (this.loadingModalProgress < 95) {
          this.loadingModalProgress = this.loadingModalProgress + 1;
        }
      }, 1000);

      return interval;
    },
    async endLoadingModal(interval, success = true) {
      clearInterval(interval);
      this.loadingModalProgress = 100;
      this.loadingModalState = success ? 'success' : 'error';

      setTimeout(() => {
        this.showLoadingModal = false;
        this.loadingModalProgress = 0;
        this.loadingModalLabel = '';
        this.loadingModalState = 'loading';
      }, 1000);
    },
    async downloadCsvErrors(errors) {
      const blob = new Blob([errors], {type: 'text/plain'});

      const link = document.createElement('a');
      link.href = URL.createObjectURL(blob);
      link.download = 'validation-errors.txt';

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(link.href);
    },
    openModal() {
      this.showModal = true;
    },
    handleViewInstructions() {
      this.showInstructionsModal = true;
    },
    closeInstructionsModal() {
      this.showInstructionsModal = false;
    },
  },
  computed: {
    columnData() {
      const data = new AudienceAvailabilityListModalData();
      if (this.scope === 'agency') {
        data.setColumns(AGENCY_COLUMNS);
        data.setRows(this.api['AGENCIES'].response.data.lookups);
      }

      if (this.scope === 'agent') {
        data.setColumns(AGENT_COLUMNS);
        data.setRows(this.api['AGENTS'].response.data.data);
      }

      return data;
    },
    disabledSubmit() {
      const scopeIsCorrect =
        (this.scope !== 'client' && this.scopeIds.length > 0) ||
        (this.scope === 'client' && this.scopeIds.length === 0);

      if (this.mode === 'create') {
        return !this.name || !this.csv || !this.scope || !scopeIsCorrect;
      } else {
        return !this.csv && !this.scope;
      }
    },
    validationErrors() {
      const defaultError = {
        name: [],
        csv: [],
        scope: [],
      };

      if (
        this.api['CREATE-AUDIENCE'] &&
        this.api['CREATE-AUDIENCE'].error &&
        this.api['CREATE-AUDIENCE'].error.response &&
        this.api['CREATE-AUDIENCE'].error.response.data &&
        this.api['CREATE-AUDIENCE'].error.response.data.errors
      ) {
        const errors = this.api['CREATE-AUDIENCE'].error.response.data.errors;
        defaultError.name = errors['name'] || [];
        defaultError.csv = errors['csv'] || [];
        defaultError.csv = defaultError.csv.map((error) =>
          error.replace(/\n/g, '<br />')
        );

        const scopeErrors = errors['scope'] || [];

        if (errors['uuids']) {
          scopeErrors.push(...errors['uuids']);

          defaultError.scope = scopeErrors;
        }
      }

      if (
        this.api['EDIT-AUDIENCE'] &&
        this.api['EDIT-AUDIENCE'].error &&
        this.api['EDIT-AUDIENCE'].error.response &&
        this.api['EDIT-AUDIENCE'].error.response.data &&
        this.api['EDIT-AUDIENCE'].error.response.data.errors
      ) {
        const errors = this.api['EDIT-AUDIENCE'].error.response.data.errors;
        defaultError.name = errors['name'] || [];
        defaultError.csv = errors['csv'] || [];
        defaultError.csv = defaultError.csv.map((error) =>
          error.replace(/\n/g, '<br />')
        );

        const scopeErrors = errors['scope'] || [];

        if (errors['uuids']) {
          scopeErrors.push(...errors['uuids']);

          defaultError.scope = scopeErrors;
        }
      }

      return defaultError;
    },
    selectList() {
      const assignments = this.assignments
        .map((item) => item.name)
        .filter((item) => item);

      return assignments.join(', ');
    },
  },
  watch: {
    scope: {
      handler() {
        this.scopeIds = [];
      },
    },
    data: {
      handler(value) {
        this.resetFormState();
        if (value) {
          this.name = value.name;
          this.csv = value.csv;
          this.scope = value.scope;
          this.assignments = value.assignments;

          this.$nextTick(() => {
            this.scopeIds = value.assignments.map(
              (assignment) => assignment.id
            );
          });
        }
      },
    },
  },
  mounted() {
    this.registerApis([
      'CREATE-AUDIENCE',
      'EDIT-AUDIENCE',
      'AGENCIES',
      'AGENTS',
      'DOWNLOAD-SAMPLE-CSV',
      'VALIDATE-CSV',
    ]);
    this.request('AGENTS', LookupServices.getAgents);
    this.request('AGENCIES', LookupServices.getAgencies);
    const hide = localStorage.getItem('hide-audience-instructions');
    this.showInstructionsModal = hide === 'true' ? false : true;
  },
};
</script>
